/**
 * Pushes are best-effort, so a live call that has not reported for this long is re-read from the
 * server in case the `ended` transition was lost.
 */
export const LIVE_CALL_RESYNC_INTERVAL_MS = 60000;
